module.exports = "/_next/static/images/UDJ1-fc5c96056c1f2c4530d8ed0d665729ca.svg";